import { formatMoney } from '@theme/utilities';
import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  constructor() {
    super();

    this.productForm = null;
  }

  connectedCallback() {
    this.productForm = this.closest('[data-ref="product-section-content"]')?.querySelector('[data-ref="product-form"]') || this.closest('[data-ref="popup-content"]')?.querySelector('[data-ref="product-form"]');

    this.productForm?.addEventListener(ThemeEvents.formUpdated, this.updatePrice);
    this.productForm?.addEventListener(ThemeEvents.variantUpdated, this.updateUnitPrice);
  }

  disconnectedCallback() {
    this.productForm?.removeEventListener(ThemeEvents.formUpdated, this.updatePrice);
    this.productForm?.removeEventListener(ThemeEvents.variantUpdated, this.updateUnitPrice);
  }

  updatePrice = (event) => {
    const priceContainer = this.querySelector('[data-ref="price-container"]');
    if (!priceContainer) return;

    const { price, compare_at_price, difference_price } = event.detail.prices;

    const priceElement = priceContainer.querySelector('[data-ref="price"]');
    if (priceElement) {
      priceElement.innerHTML = formatMoney(price);
    }

    const compareAtPriceElement = priceContainer.querySelector('[data-ref="compare-at-price"]');
    if (compareAtPriceElement) {
      compareAtPriceElement.innerHTML = compare_at_price > price ? formatMoney(compare_at_price) : '';
    }

    // Badge -X% (toujours en pourcentage)
    const differencePriceElement = priceContainer.querySelector('[data-ref="difference-price-value"]');
    if (differencePriceElement) {
      const showMinus = differencePriceElement.dataset.showMinus !== 'true';
      if (compare_at_price > price) {
        const prefix = showMinus ? '-' : '';
        const percentage = Math.round(((compare_at_price - price) * 100) / compare_at_price);
        differencePriceElement.innerHTML = `${prefix}${percentage}%`;
      } else {
        differencePriceElement.innerHTML = '';
      }
    }

    // Badge Économiser X€
    const savingsAmountElement = priceContainer.querySelector('[data-ref="savings-amount-value"]');
    const savingsBadge = priceContainer.querySelector('[data-ref="savings-badge"]');
    if (savingsAmountElement) {
      if (compare_at_price > price) {
        savingsAmountElement.innerHTML = formatMoney(difference_price);
        if (savingsBadge) savingsBadge.style.display = '';
      } else {
        savingsAmountElement.innerHTML = '';
        if (savingsBadge) savingsBadge.style.display = 'none';
      }
    }
  };

  updateUnitPrice = (event) => {
    const unitPriceElement = this.querySelector('[data-ref="unit-price"]');
    if (!unitPriceElement) return;

    const variant = event.detail.resource;
    if (!variant?.unit_price_measurement) {
      unitPriceElement.innerHTML = '';
      return;
    }

    const formattedPrice = formatMoney(variant.unit_price);
    const { reference_value, reference_unit } = variant.unit_price_measurement;
    const reference = reference_value !== 1 ? `${reference_value} ${reference_unit}` : reference_unit;
    unitPriceElement.innerHTML = `${formattedPrice} / ${reference}`;
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
